var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.249 23.1499H9.74902C9.33481 23.1499 8.99902 23.4857 8.99902 23.8999V28.3999C8.99902 28.8141 9.33481 29.1499 9.74902 29.1499H14.249C14.6632 29.1499 14.999 28.8141 14.999 28.3999V23.8999C14.999 23.4857 14.6632 23.1499 14.249 23.1499Z",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.249 23.1499H15.749C15.3348 23.1499 14.999 23.4857 14.999 23.8999V28.3999C14.999 28.8141 15.3348 29.1499 15.749 29.1499H20.249C20.6632 29.1499 20.999 28.8141 20.999 28.3999V23.8999C20.999 23.4857 20.6632 23.1499 20.249 23.1499Z",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.249 17.1499H12.749C12.3348 17.1499 11.999 17.4857 11.999 17.8999V22.3999C11.999 22.8141 12.3348 23.1499 12.749 23.1499H17.249C17.6632 23.1499 17.999 22.8141 17.999 22.3999V17.8999C17.999 17.4857 17.6632 17.1499 17.249 17.1499Z",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30V14.6102C26.0001 14.342 25.9279 14.0787 25.7912 13.8486C25.6544 13.6186 25.4582 13.4303 25.2236 13.3041L15.6903 8.17415C15.4779 8.05981 15.2408 8 15 8C14.7592 8 14.5221 8.05981 14.3097 8.17415L4.77636 13.3041C4.54176 13.4303 4.34559 13.6186 4.20884 13.8486C4.07209 14.0787 3.99991 14.342 4 14.6102V30",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationStock);
export default __webpack_public_path__ + "static/media/OperationStock.030b5ec7bcf9585a751dba92a777baf0.svg";
export { ForwardRef as ReactComponent };